import Vue from 'vue'
import VueRouter from 'vue-router'
const ShouTu = () => import('@/views/ShouTu.vue')
const GuiZhe = () => import('@/views/GuiZhe.vue')
const ShuoMing = () => import('@/views/ShuoMing.vue')
const TiXian = () => import('@/views/TiXian.vue')
const XieYi = () => import('@/views/XieYi.vue')
const YingShi = () => import('@/views/YingShi.vue')
const HeTong = () => import('@/views/HeTong.vue')
const HeTongXieYi = () => import('@/views/HeTongXieYi.vue')
const SolidarityPacts = () => import('@/views/solidarityPacts.vue')
const MuLu = () => import('@/views/MuLu.vue')
const ShouCe = () => import('@/views/ShouCe.vue')
const RJGS = () => import('@/views/shouce/RJGS.vue')
const ZCSM = () => import('@/views/shouce/ZCSM.vue')
const XMGL = () => import('@/views/shouce/XMGL.vue')
const TJCY = () => import('@/views/shouce/TJCY.vue')
const CYGL = () => import('@/views/shouce/CYGL.vue')
const RWGL = () => import('@/views/shouce/RWGL.vue')
const OASP = () => import('@/views/shouce/OASP.vue')
const GRSZ = () => import('@/views/shouce/GRSZ.vue')
const WDBR = () => import('@/views/shouce/WDBR.vue')
const STZQ = () => import('@/views/shouce/STZQ.vue')
const XinXiangMuXieYi = () => import('@/views/XinXiangMuXieYi.vue')
const DengJiGongLue = () => import('@/views/DengJiGongLue.vue')
const ZiJinShuoMing = () => import('@/views/ZiJinShuoMing.vue')
const FuWuFeiGuiZhe = () => import('@/views/FuWuFeiGuiZhe.vue')
const CaoZuoZhiNan = () => import('@/views/czzn/CaoZuoZhiNan.vue')
const CaoZuoXiangQing = () => import('@/views/czzn/CaoZuoXiangQing.vue')
const ShiGongRiZhi = () => import('@/views/xiangmubu/ShiGongRiZhi.vue')
const GetTitcket = () => import('@/views/getTitcket.vue')


Vue.use(VueRouter)

const routes = [
  {
    path:'/inviteMsg',
    name:'inviteMsg',
    component: () => import('@/views/inviteMsg.vue')
  },
  // {
  //   path: "/",
  //   name: "index",
  //   component: () => import('@/views/index/index.vue'),
  // },
  // 赚金币
  {
    path:'/earnGold',
    name:'EarnGold',
    component: GetTitcket
  },
  //领门票
  {
    path:'/getTitcket',
    name:'GetTitcket',
    component: () => import('@/views/getTitcket.vue')
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/views/pages/2.2.0/payment.vue')
  },
  {
    path: '/finishi',
    name: 'finishi',
    component: () => import('@/views/pages/2.2.0/finishi.vue')
  },
  // 活动专题
  {
    path: '/activity',
    name: 'Activity',
    component: () => import('@/views/activity/activityList')
  },
  //操作指南
  {
    path: '/caozuozhinan',
    name: 'CaoZuoZhiNan',
    component: CaoZuoZhiNan
  },
  //操作指南详情
  {
    path: '/caozuoxiangqing',
    name: 'CaoZuoXiangQing',
    component: CaoZuoXiangQing
  },
  //收徒赚钱页面
  {
    path: '/shoutu',
    name: 'ShouTu',
    component: ShouTu
  },
  //赚取奖金规则页面
  {
    path: '/guizhe',
    name: 'GuiZhe',
    component: GuiZhe
  },
  //项目服务费规则页面
  {
    path: '/fuwufeiguizhe',
    name: 'FuWuFeiGuiZhe',
    component: FuWuFeiGuiZhe
  },
  //证书升降级规则页面
  {
    path: '/shuoming',
    name: 'ShuoMing',
    component: ShuoMing
  },
  //提现规则页面
  {
    path: '/tixian',
    name: 'TiXian',
    component: TiXian
  },
  //服务协议页面
  {
    path: '/xieyi',
    name: 'XieYi',
    component: XieYi
  },
  //隐私政策页面
  {
    path: '/yingshi',
    name: 'YingShi',
    component: YingShi
  },
  //劳动合同页面
  {
    path: '/hetong',
    name: 'HeTong',
    component: HeTong
  },
  //劳动合同和补充协议页面
  {
    path: '/hetongxieyi',
    name: 'HeTongXieYi',
    component: HeTongXieYi
  },
  //新项目协议页面
  {
    path: '/xinxiangmuxieyi',
    name: 'XinXiangMuXieYi',
    component: XinXiangMuXieYi
  },
  //等级攻略页面
  {
    path: '/dengjigonglue',
    name: 'DengJiGongLue',
    component: DengJiGongLue
  },
  //资金说明页面
  {
    path: '/zijinshuoming',
    name: 'ZiJinShuoMing',
    component: ZiJinShuoMing
  },
  //操作手册目录页面
  {
    path: '/mulu',
    name: 'MuLu',
    component: MuLu
  },
  {
    path: '/shigongrizhi',
    name: 'ShiGongRiZhi',
    component: ShiGongRiZhi,
  },
  // 合伙人协议
  {
    path: '/solidarityPacts',
    name: 'solidarityPacts',
    component: SolidarityPacts,
  },

  //操作手册软件概述页面
  {
    path: '/shouce',
    name: 'ShouCe',
    component: ShouCe,
    children: [
      //操作手册软件概述页面
      {
        path: 'rjgs',
        name: 'RJGS',
        component: RJGS
      },
      //操作手册注册实名页面
      {
        path: 'zcsm',
        name: 'ZCSM',
        component: ZCSM
      },
      //操作手册项目管理页面
      {
        path: 'xmgl',
        name: 'XMGL',
        component: XMGL
      },
      //操作手册添加成员页面
      {
        path: 'tjcy',
        name: 'TJCY',
        component: TJCY
      },
      //操作手册成员管理页面
      {
        path: 'cygl',
        name: 'CYGL',
        component: CYGL
      },
      //操作手册任务管理页面
      {
        path: 'rwgl',
        name: 'RWGL',
        component: RWGL
      },
      //操作手册OA审批页面
      {
        path: 'oasp',
        name: 'OASP',
        component: OASP
      },
      //操作手册OA审批页面
      {
        path: 'grsz',
        name: 'GRSZ',
        component: GRSZ
      },
      //操作手册OA审批页面
      {
        path: 'wdbr',
        name: 'WDBR',
        component: WDBR
      },
      //操作手册OA审批页面
      {
        path: 'stzq',
        name: 'STZQ',
        component: STZQ
      }
    ]
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to) {
    if (to.name === 'GuiZhe') {
      return { x: 0, y: 0 }
    } else {
      return {}
    }
  }
})

export default router
